<template>
  <div class="devices">
    <div class="header">
      <div class="title">Devices</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="info-container">
          These are the devices being used by your account. If you click on Revoke Access, the refresh token will be revoked, forcing the user to re-login on the application. It is recommended to revoke access if you found an unknown device.
        </div>
        <div class="info-container">
          <div class="tr">
            <div class="th">Device</div>
            <div class="th">Last access</div>
            <div class="th"></div>
          </div>
          <div class="tr">
            <div class="td">Monitoring portal chrome</div>
            <div class="td">October 29th, 2018</div>
            <div class="td">Revoke Access</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'devices'
}
</script>

<style scoped>


.devices {
  /* common */
  color: #fefefe;
  /* size */
  max-width: 700px;
  width: 100%;
  height: 100%;
}

.devices .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 40px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.devices .header .title {
  /* common */
  font-size: 3em;
  
}
.devices .header .description {
  /* common */
  font-size: 2em;
}


.devices .body {
  /* size */
  padding: 0 16px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 100%, 0.1);
  /* alignment */
  text-align: left;
}

.devices .body .content {
  /* common */
  color: #fefefe;
  font-size: 16px;
  /* size */
  min-width: 240px;
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}

.devices .body .content .info-container:first-child {
  margin-top: 0;
}
.devices .body .content .info-container {
  /* common */
  font-size: 14px;
  /* size */
  width: 100%;
  margin: 1em 0;
  /* alignment */
  display: table;
}

.devices .body .content .tr {
  /* size */
  padding: 0;
  /* alignment */
  display: table-row;
}
.devices .body .content .td {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  color: #000;
  /* size */
  padding: 1em;
  /* alignment */
  display: table-cell;
}
.devices .body .content .th {
  /* common */
  background-color: hsla(0, 100%, 100%, 0.1);
  /* size */
  padding: 1em;
  /* alignment */
  display: table-cell;
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// src/pages/Account/Devices.vue